import { ContextsService, type ConversationSummaryDto } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/inference-client';

export type ConversationSummary = ConversationSummaryDto;

/** Enough for any conversation a test runs; the marker for each is drawn in the thread. */
const PAGE_SIZE = 100;

/** Where the conversation was summarized, newest first. */
export async function listConversationSummaries(contextId: string): Promise<ConversationSummary[]> {
  const response = await ContextsService.getSummaries({
    client: inferenceHttp,
    throwOnError: true,
    path: { contextId },
    query: { pageSize: PAGE_SIZE },
  });
  return response.data.data;
}

/** Summarizes the conversation now, with the draft it tests when it is a test of one. */
export async function compactConversation(
  contextId: string,
  draft: boolean,
): Promise<ConversationSummary> {
  const response = await ContextsService.compact({
    client: inferenceHttp,
    throwOnError: true,
    path: { contextId },
    body: { draft },
  });
  return response.data;
}
